"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import ViewContentTracker from "@/app/_components/ViewContentTracker";
import { trackEvent } from "@/utils/analytics";

function RequestPage() {
  const path = usePathname();
  useEffect(() => {
    trackEvent("page_view", path, {
      referrer_page: document.referrer || "",
    });
  }, []);

  return <ViewContentTracker contentName="상담 신청 페이지" contentCategory="lead_form" contentIds="request_form" />;
}

export default RequestPage;
